import {
  READ_CLIENT,
  READ_COMPANY,
  READ_EXPENSE,
  READ_EXPENSE_TYPE,
  READ_INVOICE,
  READ_LOCATION,
  READ_MIKROTIK,
  READ_PAYMENT_ENTRY,
  READ_PAYMENT_TYPE,
  READ_PRODUCT,
  READ_PURCHASE,
  READ_PURCHASE_QUOTATION,
  READ_PURCHASE_QUOTATION_REQUEST,
  READ_REPORT,
  READ_ROLE,
  READ_SALE,
  READ_SESSION,
  TEST_PERMISSION,
  READ_SUBSCRIPTION,
  READ_SUPPLIER,
  READ_TICKET,
  READ_TICKET_TYPE,
  READ_USER,
  READ_WAREHOUSE,
  READ_WAREHOUSE_ENTRY,
  READ_CORP,
  READ_ACCOUNT,
  READ_TAX,
  READ_PUESTO,
  READ_EMPLOYEE,
  READ_VEHICLE_BRAND,
  READ_VEHICLE,
  READ_EMPLOYEE_INCIDENT,
  READ_EMPLOYEE_INCIDENT_TYPE,
  READ_PROMOTION,
  READ_PAYROLL,
  VIEW_CALL,
  READ_OLT,
  READ_EXPENSE_RECURRENCE,
  READ_PRODUCT_FAMILY,
  READ_PROPERTY,
  READ_BRAND,
  READ_EQUIPMENT,
  READ_DEPOSIT,
  READ_PROJECT,
  READ_PURCHASE_REQUEST,
  READ_FIXED_ASSET,
  READ_ESTABLISHMENT,
  READ_BANK,
  VIEW_CORPORATE_FINANCE,
  READ_COLLECTOR_VISIT,
  READ_SHIPMENT,
  READ_INVOICE_PAYMENT,
  READ_RACK,
} from './permissions';

// Elementos de acceso rápido predeterminados del sistema
export const defaultQuickAccessItems = [
  /* { label: 'Clientes', path: '/client', can: READ_CLIENT, icon: 'users' },
  { label: 'Suscripciones', path: '/subscription', can: READ_SUBSCRIPTION, icon: 'calendar alternate' },
  { label: 'Facturas', path: '/invoice', can: READ_INVOICE, icon: 'file alternate' },
  { label: 'Transacciones', path: '/payment-entry', can: READ_PAYMENT_ENTRY, icon: 'payment' },
  { label: 'Reportes', path: '/report', can: READ_REPORT, icon: 'chart line' }, */
];

// Todos los elementos de menú disponibles en el sistema (planos)
export const allMenuItems = [
  // Acceso rápido predeterminado
  ...defaultQuickAccessItems,
  //dashboard
  { label: 'Reportes', path: '/report', can: READ_REPORT, icon: 'chart line', category: 'Dashboard' },
  // Clientes
  { label: 'Clientes', path: '/client', can: READ_CLIENT, icon: 'users', category: 'Clientes' },
  { label: 'Llamadas', path: '/calls', can: VIEW_CALL, icon: 'phone', category: 'Llamadas' },
  { label: 'Visitas a Clientes', path: '/client-visit', can: READ_COLLECTOR_VISIT, icon: 'map marker alternate', category: 'Clientes' },
  { label: 'Suscripciones', path: '/subscription', can: READ_SUBSCRIPTION, icon: 'calendar alternate', category: 'Clientes' },
  { label: 'Ventas', path: '/sale', can: READ_SALE, icon: 'shopping cart', category: 'Clientes' },

  // Clientes Corporativos

  { label: 'Clientes Corp.', path: '/clientCorporate', can: READ_CORP, icon: 'address card', category: 'Clientes Corporativos' },
  { label: 'Suscripciones Corp.', path: '/clientCorporate/subscriptions', can: READ_CORP, icon: 'calendar alternate', category: 'Clientes Corporativos' },
  { label: 'Dashboard', path: '/clientCorporate/dashboard', can: VIEW_CORPORATE_FINANCE, icon: 'money bill alternate', category: 'Clientes Corporativos' },

  // Soporte
  { label: 'Tickets', path: '/ticket', can: READ_TICKET, icon: 'tasks', category: 'Soporte' },
  { label: 'Tipo de Tickets', path: '/ticket-type', can: READ_TICKET_TYPE, icon: 'tasks', category: 'Soporte' },
  { label: 'Razones de Tickets', path: '/ticket-Subtype', can: READ_TICKET_TYPE, icon: 'tasks', category: 'Soporte' },
  { label: 'Tipos de Cancelación', path: '/ticketCancellation', can: READ_TICKET, icon: 'tasks', category: 'Soporte' },
  // Finanzas
  { label: 'Facturas', path: '/invoice', can: READ_INVOICE, icon: 'file alternate', category: 'Finanzas' },
  { label: 'Abonos', path: '/invoice-payment', can: READ_INVOICE_PAYMENT, icon: 'file alternate', category: 'Finanzas' },
  { label: 'Transacciones', path: '/payment-entry', can: READ_PAYMENT_ENTRY, icon: 'payment', category: 'Finanzas' },
  { label: 'Gastos', path: '/expense', can: READ_EXPENSE, icon: 'id badge', category: 'Finanzas' },
  { label: 'Gastos Recurrentes', path: '/expense-recurrence', can: READ_EXPENSE_RECURRENCE, icon: 'money', category: 'Finanzas' },
  { label: 'Tipo de Gastos', path: '/expense-type', can: READ_EXPENSE_TYPE, icon: 'id badge', category: 'Finanzas' },
  { label: 'Caja y Bancos', path: '/payment-type', can: READ_PAYMENT_TYPE, icon: 'university', category: 'Finanzas' },
  { label: 'Cuentas', path: '/account', can: READ_ACCOUNT, icon: 'book', category: 'Finanzas' },
  { label: 'Impuestos', path: '/tax', can: READ_TAX, icon: 'percent', category: 'Finanzas' },
  { label: 'Depósitos', path: '/deposit', can: READ_DEPOSIT, icon: 'money bill alternate', category: 'Finanzas' },


  // Inventario
  { label: 'Inventario', path: '/warehouse-entry', can: READ_WAREHOUSE_ENTRY, icon: 'dolly', category: 'Inventario' },
  { label: 'Bodegas', path: '/warehouse', can: READ_WAREHOUSE, icon: 'warehouse', category: 'Inventario' },
  { label: 'Marcas', path: '/brand', can: READ_BRAND, icon: 'tags', category: 'Inventario' },

  // Compras
  { label: 'Proveedores', path: '/supplier', can: READ_SUPPLIER, icon: 'handshake', category: 'Proveedores' },
/*   { label: 'Solicitudes de Compra', path: '/material-request', can: READ_MATERIAL_REQUEST, icon: 'clipboard list', category: 'Compras' },
 */  { label: 'Solicitudes de Compra', path: '/purchase-request', can: READ_PURCHASE_REQUEST, icon: 'clipboard list', category: 'Compras' },
  { label: 'Solicitudes de cotización', path: '/purchase-quotation-request', can: READ_PURCHASE_QUOTATION_REQUEST, icon: 'file', category: 'Compras' },
  { label: 'Cotizaciones', path: '/purchase-quotation', can: READ_PURCHASE_QUOTATION, icon: 'file alternate', category: 'Compras' },
/*   { label: 'Envios', path: '/purchase', can: READ_PURCHASE, icon: 'shopping bag', category: 'Compras' },
 */  { label: 'Envios', path: '/shipment', can: READ_SHIPMENT, icon: 'shipping fast', category: 'Compras' },
  {
    label: 'Productos',
    path: '/product',
    can: READ_PRODUCT,
    icon: 'boxes',
    category: 'Compras',
    subItems: [
      { label: 'Servicios', path: '/product/service', can: READ_PRODUCT, icon: 'cogs' },
      { label: 'Artículos', path: '/product/item', can: READ_PRODUCT, icon: 'box' }
    ]
  },
  { label: 'Familias de Producto', path: '/product-family', can: READ_PRODUCT_FAMILY, icon: 'boxes', category: 'Compras' },
  { label: 'Proyectos', path: '/project', can: READ_PROJECT, icon: 'building', category: 'Compras' },

  // Recursos de Red
  { label: 'Mikrotiks', path: '/mikrotik', can: READ_MIKROTIK, icon: 'hdd outline', category: 'Recursos de Red' },
  { label: 'Onus', path: '/onus', can: READ_MIKROTIK, icon: 'microchip', category: 'Recursos de Red' },
  { label: 'OLTs', path: '/olt', can: READ_OLT, icon: 'server', category: 'Recursos de Red' },

  // Administración
  { label: 'Empresas', path: '/company', can: READ_COMPANY, icon: 'building', category: 'Administración' },
  { label: 'Establecimientos', path: '/establishment', can: READ_ESTABLISHMENT, icon: 'building', category: 'Administración' },

  { label: 'Ubicaciones', path: '/location', can: READ_LOCATION, icon: 'globe', category: 'Administración' },
  { label: 'Promociones', path: '/promotion', can: READ_PROMOTION, icon: 'gift', category: 'Administración' },


  { label: 'Incidencias Empleado', path: '/employee-incidents', can: READ_EMPLOYEE_INCIDENT, icon: 'user', category: 'RRHH' },
  { label: 'Tipos de Incidencias', path: '/employee-incidents/type', can: READ_EMPLOYEE_INCIDENT_TYPE, icon: 'list ul', category: 'RRHH' },

  // Vehículos
  { label: 'Vehículos', path: '/vehicle', can: READ_VEHICLE, icon: 'car', category: 'Vehículos' },
  { label: 'Marcas de Vehículos', path: '/vehicle-brand', can: READ_VEHICLE_BRAND, icon: 'car', category: 'Vehículos' },
  //RRHH
  { label: 'Empleados', path: '/empleado', can: READ_EMPLOYEE, icon: 'user', category: 'RRHH' },
  { label: 'Puestos', path: '/puesto', can: READ_PUESTO, icon: 'briefcase', category: 'RRHH' },
  { label: 'Activos Fijos', path: '/fixed-assets', can: READ_FIXED_ASSET, icon: 'building outline', category: 'RRHH' },
  //{ label: 'Conceptos Empleado', path: '/employee-concepts', can: READ_SUBSCRIPTION, icon: 'user', category: 'RRHH' },
  { label: 'Nomina', path: '/payroll', can: READ_PAYROLL, icon: 'numbered list', category: 'RRHH' },

  //INMUEBLES
  { label: 'Inmuebles', path: '/property', can: READ_PROPERTY, icon: 'building outline', category: 'Inmuebles' },
  { label: 'Equipos', path: '/equipment', can: READ_EQUIPMENT, icon: 'hdd outline', category: 'Inmuebles' },
  { label: 'Racks', path: '/rack', can: READ_RACK, icon: 'sitemap', category: 'Inmuebles' },

  { label: 'Roles', path: '/role', can: READ_ROLE, icon: 'address card', category: 'Administración' },
  { label: 'Usuarios', path: '/user', can: READ_USER, icon: 'user', category: 'Administración' },
  { label: 'Sesiones', path: '/session', can: READ_SESSION, icon: 'desktop', category: 'Administración' },
  { label: 'Bancos', path: 'bank', can: READ_BANK, icon: 'university', category: 'Finanzas' },

  {
    label: 'Tareas',
    path: '/task',
    can: READ_TICKET,
    icon: 'check square outline',
    category: 'Soporte'
  },


];

// Estructura de categorías para el menú
export const categoryMenuItems = [
  {
    category: "Dashboard",
    icon: "line graph",
    items: allMenuItems.filter(item => item.category === 'Dashboard')
  },
  {
    category: "Clientes",
    icon: "users",
    items: allMenuItems.filter(item => item.category === 'Clientes')
  },
  {
    category: "Llamadas",
    icon: "phone",
    items: allMenuItems.filter(item => item.category === 'Llamadas')
  },
  {
    category: "Clientes Corporativos",
    icon: "building",
    items: allMenuItems.filter(item => item.category === 'Clientes Corporativos')
  },
  {
    category: "Soporte",
    icon: "tasks",
    items: allMenuItems.filter(item => item.category === 'Soporte')
  },
  {
    category: "Finanzas",
    icon: "money bill alternate",
    items: allMenuItems.filter(item => item.category === 'Finanzas')
  },
  {
    category: "Inventario",
    icon: "boxes",
    items: allMenuItems.filter(item => item.category === 'Inventario')
  },
  {
    category: "Compras",
    icon: "shopping bag",
    items: allMenuItems.filter(item => item.category === 'Compras')
  },
  {
    category: "Proveedores",
    icon: "box",
    items: allMenuItems.filter(item => item.category === 'Proveedores')
  },
  {
    category: "Recursos de Red",
    icon: "server",
    items: allMenuItems.filter(item => item.category === 'Recursos de Red')
  },
  {
    category: "Vehículos",
    icon: "car",
    items: allMenuItems.filter(item => item.category === 'Vehículos')
  },
  {
    category: "RRHH",
    icon: "address card",
    items: allMenuItems.filter(item => item.category === 'RRHH')
  },
  {
    category: "Inmuebles",
    icon: "warehouse",
    items: allMenuItems.filter(item => item.category === 'Inmuebles')
  },
  {
    category: "Administración",
    icon: "cogs",
    items: allMenuItems.filter(item => item.category === 'Administración')
  },
];

// Obtener un elemento del menú por su ruta
export const getMenuItemByPath = (path) => {
  return allMenuItems.find(item => item.path === path);
};